import { createFileRoute } from "@tanstack/react-router";

import { MorrowTeamPage } from "../components/workspace/MorrowTeamPage";

export type TeamSearch = {
  readonly member?: string;
};

export const Route = createFileRoute("/team")({
  validateSearch: (raw: Record<string, unknown>): TeamSearch => ({
    ...(typeof raw.member === "string" && raw.member ? { member: raw.member.slice(0, 200) } : {}),
  }),
  component: MorrowTeamPage,
});
